import React, { Component, PropTypes } from 'react';
import {Link} from 'react-router';
import { connect } from 'react-redux';
import {GetSubscription} from '../../actions/index';

class Subscription extends Component {
     static contextTypes = {
        router: PropTypes.object
    };
    constructor(props){
        super(props);
    }
     componentWillMount(){
        let token = localStorage.getItem('id_token_admin');
        this.props.GetSubscription(token);
    }
    render() {
        return (
            <div className="dashboard-wrapper">
                <div className="dashboard-title clearfix"><p className="pull-left">Subscription</p></div>
                <div>
                    <div className="col-md-12">
                        <Link to={"subscription/packages"} className="white-block common-list second clearfix">
                            <p>Packages</p>
                            <p> {this.props.subscription.stats ? this.props.subscription.stats.packages : ''} packages</p>
                        </Link>
                        <Link to={"subscription/coupons"} className="white-block common-list second clearfix">
                            <p>Coupons</p>

                            <p>{this.props.subscription.stats ? this.props.subscription.stats.coupons : ''} coupons</p>
                        </Link>

                    </div>
                </div>
                <div className="clearfix"></div>
            </div>
            
        );
    }
}

function  mapStateToProps(state) {
    return{
        subscription: state.subscription
    }
}
export default connect(mapStateToProps, {GetSubscription})(Subscription);



// WEBPACK FOOTER //
// ./src/components/subscription/subscription.js